import { jwtDecode } from 'jwt-decode';

import { getInvestorSession, hasLiveInvestorSession } from './investor-session.service';

import { logger } from '@/lib/logger';

type TInvestorClaims = {
  parentMerchantId: string;
};

// We read ONLY parent_merchant_id from the JWT — never the PAN-bearing claim. Never send the raw
// token or any other claim.
export const decodeInvestorClaims = (token: string): TInvestorClaims | null => {
  try {
    const { parent_merchant_id: parentMerchantId } = jwtDecode<{ parent_merchant_id?: string }>(token);
    if (!parentMerchantId) {
      logger.error('investor session token is missing an expected claim', { hasParentMerchantId: false });
      return null;
    }

    return { parentMerchantId };
  } catch {
    logger.error('investor session token could not be decoded', { hasToken: true });
    return null;
  }
};

export const readLiveSessionParentMerchantId = (): string | undefined => {
  const session = getInvestorSession();
  if (!session || !hasLiveInvestorSession()) return undefined;
  return decodeInvestorClaims(session.token)?.parentMerchantId;
};
